import { Matiere, COEF_OPTION1, COEF_OPTION2 } from '../types/main';

// épreuves anticipées
export const COEF_FRANCAIS_ECRIT = 2;
export const COEF_FRANCAIS_ORAL = 2;
export const COEF_TPE = 2;
export const COEF_SCIENCES = 2;

// contrôle continu
export const COEF_ECO_APP = 2;
export const COEF_SSP = 2;
export const COEF_HG = 5;
export const COEF_MATHS_SIPASSPE = 5;
export const COEF_MATHS_PASSPE_SI_SPE = 7 * 0.75;
export const COEF_MATHS_SPE = 7 * 0.25;
export const COEF_SES = 7;
export const COEF_LV1 = 3;
export const COEF_LV2 = 2;
export const COEF_PHILO = 4;
export const COEF_EPS = 2;
export const COEF_EPS_COMP = 2;

export const matieres_EA_ES = [
  {
    name: 'francais_ecrit',
    label: 'Français Ecrit',
    coef: COEF_FRANCAIS_ECRIT,
  },
  {
    name: 'francais_oral',
    label: 'Français Oral',
    coef: COEF_FRANCAIS_ORAL,
  },
  {
    name: 'TPE',
    label: 'TPE',
    coef: COEF_TPE,
    pointsAuDessus10: true,
  },
  {
    name: 'sciences',
    label: 'Sciences',
    coef: COEF_SCIENCES,
  },
] as Matiere[];

export const matieres_ES = [
  {
    name: 'hist_geo',
    label: 'Histoire - Géographie',
    coef: COEF_HG,
  },
  {
    name: 'maths',
    label: 'Mathématiques',
    coef: COEF_MATHS_SIPASSPE,
    spe: false,
  },
  {
    name: 'maths_spe',
    label: 'Mathématiques',
    coef: COEF_MATHS_SPE,
    spe: false,
  },
  {
    name: 'eco_appr',
    label: 'Economie approfondie',
    coef: COEF_ECO_APP,
    spe: false,
  },
  {
    name: 'SSP',
    label: 'Sciences sociales et politiques',
    coef: COEF_SSP,
    spe: false,
  },
  {
    name: 'SES',
    label: 'SES',
    coef: COEF_SES,
  },
  {
    name: 'LV1',
    label: 'LV1',
    coef: COEF_LV1,
  },
  {
    name: 'LV2',
    label: 'LV2',
    coef: COEF_LV2,
  },
  {
    name: 'philo',
    label: 'Philosophie',
    coef: COEF_PHILO,
  },
  {
    name: 'EPS',
    label: 'EPS',
    coef: COEF_EPS,
  },
  {
    name: 'EPS_comp',
    label: 'EPS de complément',
    coef: COEF_EPS_COMP,
    facultatif: true,
  },
] as Matiere[];
